import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Message } from 'rsuite'
import { Row, Col, ControlLabel, FormGroup } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ProjectNameForm from './ProjectNameForm'
import ProjectNameView from './ProjectNameView'
import {
  getProjectName,
  updateProjectName,
  saveProjectName,
  saveSubProjectName,
  updateSubProjectName,
} from '../../../redux/actions/projectName'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../../redux/actions/sidebar'
import ButtonPanel from '../../ButtonPanel'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function ProjectNameWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, isSubProject } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [reservedWords, setReservedWords] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleCallService = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateProjectName(id, request)
      } else {
        console.log('call save.')
        response = await saveProjectName(id, request)
      }

      console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(id))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallServiceSubProject = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateSubProjectName(id, request)
      } else {
        console.log('call save.')
        response = await saveSubProjectName(id, request)
      }

      console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSubProjectSidebar(id))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    if (!reservedWords) {
      let request = {
        id: formSchema.id,
        projectVersionId: projectId,
        formTemplate: formSchema.formTemplate,
        projectNameTH: data.projectNameTH,
        projectNameEN: data.projectNameEN,
        projectVar1: data.projectVar1,
        projectVar2: data.projectVar2,
        projectVar3: data.projectVar3,
        projectVar4: data.projectVar4,
        projectVar5: data.projectVar5,
      }

      // console.log('request', request)
      if (isSubProject) {
        handleCallServiceSubProject(projectId, request)
      } else {
        handleCallService(projectId, request)
      }
    }
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {isEdit && showCommandButton ? (
        <ProjectNameForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          reservedWords={reservedWords}
          setReservedWords={setReservedWords}
        />
      ) : (
        <ProjectNameView schema={formSchema} />
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading || reservedWords}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}
